import React,{useRef,useState,useEffect} from 'react';
import {DataTable,QuotationInfoCard} from '../../Components'
import { Controller, set, useForm } from "react-hook-form";
import { createRoot } from 'react-dom/client';
import { DateFormat,APIURL, DateFormatJSON } from '../../Utils/Function';
import {QuotationType,QuotationTypeName,OrderStatus,OrderStatusList} from '../../Utils/Status';
import Swal from 'sweetalert2';
import API from '../../API';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from "@fullcalendar/interaction"
import thLocale from '@fullcalendar/core/locales/th';
import {OrderCardInfo} from '../../Components/OrderCard';
import { Calendar } from '@fullcalendar/core/index.js';
const PageCalendar =()=> {
    const { register, getValues, setValue } = useForm();
    const [_EventList,setEventList] = useState([]);
    const [_DateInfo,setDateInfo] = useState(null);
    const [_CalendarType,setCalendarType] = useState(0);
    const [_AccountType,setAccountType] = useState(['1','2']);
    const [_CalendarStatus,setCalendarStatus] = useState(0);
    const _QuotationInfoCard = useRef();
    const _OrderInfoCard = useRef();
    const _CalendarRef = useRef();
    const [_CalendarView,setCalendarView] = useState('dayGridMonth');
    const [_QuotationType,setQuotationType] = useState(()=>QuotationType.map(v=>String(v)));
    const [_OrderStatusList,setOrderStatusList] = useState(0);
    useEffect(() => {
        (async () => {
            //await _LoadQuotationStatus();
        })();

        return ()=>{ }
    }, []);
    const handleEventClick = (arg) => {
        if(arg.event._def.extendedProps.CalendarID === undefined) return;
        const _CalendarID = arg.event._def.extendedProps.CalendarID;
        _GetEvent(_CalendarID);
    }
    const _Search = async() =>{
        _LoadEvent(_DateInfo.start, _DateInfo.end);
    }
    const _LoadEvent = async(Start,End)=>{
        Swal.showLoading();
        API({method : "get",url:"/Calendar/Event?StartDate="+DateFormatJSON(Start,false)+'&EndDate='+DateFormatJSON(End,false)+'&CalendarType='+(_QuotationType.length>0?_QuotationType.join(','):0)+'&AccountType='+(_AccountType.length>0?_AccountType.join(','):0)+'&CalendarStatus='+_OrderStatusList}).then(res=>{
            if (res.status !== 200) {
                Swal.close();
                return;
            }
    
            if (!res.data.Status) {
                Swal.close();
                return;
            }
            setEventList(res.data.Data);
            Swal.close();
        }).catch(res => {
            Swal.fire({
                icon: 'error',
                title: res.data.Message,
            });
            return;
        });
    }

    const _GetEvent = async(CalendarID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Calendar/Event/"+CalendarID}).then(res=>{
            if (res.status !== 200) {
                Swal.close();
                return;
            }
    
            if (!res.data.Status) {
                Swal.close();
                return;
            }
            Swal.close();
            switch(res.data.Data.RefType){
                case 'QEVEN':
                    _LoadOrderEvent(res.data.Data.RefId);
                break;
            }
        }).catch(res => {
            Swal.close();
            return;
        });
    }

    
    const _LoadOrderEvent = async(QuotationEventID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Order/Quotation/Event/"+QuotationEventID}).then(res=>{
            Swal.close();
            if (res.status !== 200) {
                return;
            }
            if (!res.data.Status) {
                return;
            }
            _OrderInfoCard.current?.Show(res.data.Data.OrderId);
        }).catch(res => {
            Swal.close();
            return;
        });
    }

    const _LoadQuotationEvent = async(QuotationEventID) =>{
        Swal.showLoading();
        API({method : "get",url:"/Quotation/Event/"+QuotationEventID}).then(res=>{
            Swal.close();
            if (res.status !== 200) {
                return;
            }
            if (!res.data.Status) {
                return;
            }
            _QuotationInfoCard.current?.Show(res.data.Data.QuotationId);
        }).catch(res => {
            Swal.close();
            return;
        });
    }
    return (
        <>
        <React.Fragment>
            <div className='container-fluid'>
                <div className='row mt-2 mb-2 justify-content-end'>
                    <div className='col-auto mt-2'>
                        <div className='d-flex flex-wrap gap-1 mb-3'>
                            {[{v:'1',l:'บริษัท'},{v:'2',l:'ร้าน'}].map(({v,l})=>(
                                <span key={v} onClick={()=>setAccountType(p=>p.includes(v)?p.filter(x=>x!==v):[...p,v])}
                                    style={{cursor:'pointer',userSelect:'none'}}
                                    className={`badge rounded-pill ${_AccountType.includes(v)?'bg-success':'bg-secondary'}`}>
                                    #{l}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className='col-auto mt-2'>
                        <div className='d-flex flex-wrap gap-1 mb-3'>
                            {QuotationType.map((v,i)=>(
                                <span key={i} onClick={()=>setQuotationType(p=>p.includes(String(v))?p.filter(x=>x!==String(v)):[...p,String(v)])}
                                    style={{cursor:'pointer',userSelect:'none'}}
                                    className={`badge rounded-pill ${_QuotationType.includes(String(v))?'bg-success':'bg-secondary'}`}>
                                    #{QuotationTypeName(v)}
                                </span>
                            ))}
                        </div>
                    </div>
                    <div className='col-lg-2'>
                        <div className="input-group mb-3">
                            <select className='form-control text-center' value={_OrderStatusList} onChange={(e)=>{setOrderStatusList(e.target.value);}} >
                                <option value={0}>สถานะ</option>
                                {OrderStatusList.map((v,i)=>(
                                        <option key={i} value={v}>{OrderStatus(v)}</option>
                                    ))}
                            </select>
                        </div>
                    </div>
                    <div className='col-lg-1 text-end'>
                        <button type='button' style={{'width':'80px'}} className='btn btn-info text-white' onClick={()=>{_Search();}}>ค้นหา</button>
                    </div>
                </div>
                <div className='row justify-content-end align-items-center mb-2'>
                    {_CalendarView!=='dayGridMonth' && <div className='col-auto'>
                        <input
                            type='date'
                            className='form-control'
                            onChange={(e)=>{
                                if(!e.target.value) return;
                                _CalendarRef.current?.getApi().gotoDate(e.target.value);
                            }}
                        />
                    </div>}
                    <div className='col-auto'>
                        <div className='btn-group'>
                            <button type="button" className={`btn ${_CalendarView==='dayGridMonth'?'btn-success':'btn-outline-success'}`} onClick={()=>{ setCalendarView('dayGridMonth'); _CalendarRef.current?.getApi().changeView('dayGridMonth'); }}>เดือน</button>
                            <button type="button" className={`btn ${_CalendarView==='timeGridWeek'?'btn-success':'btn-outline-success'}`} onClick={()=>{ setCalendarView('timeGridWeek'); _CalendarRef.current?.getApi().changeView('timeGridWeek'); }}>สัปดาห์</button>
                            <button type="button" className={`btn ${_CalendarView==='timeGridDay'?'btn-success':'btn-outline-success'}`} onClick={()=>{ setCalendarView('timeGridDay'); _CalendarRef.current?.getApi().changeView('timeGridDay'); }}>วัน</button>
                        </div>
                    </div>
                </div>
                <div className='row mt-2'>
                    <div className='col-lg-12'>
                        <FullCalendar
                        ref={_CalendarRef}
                        plugins={[ dayGridPlugin,timeGridPlugin,interactionPlugin ]}
                        locale={thLocale}
                        initialView="dayGridMonth"
                        eventClick={handleEventClick}
                        datesSet={(dateInfo) => {
                            setDateInfo({...dateInfo});
                            _LoadEvent(dateInfo.start,dateInfo.end);
                        }}
                        events={_EventList}
                        />
                    </div>
                </div>
            </div>
        </React.Fragment>
        <QuotationInfoCard ref={_QuotationInfoCard}/>
        <OrderCardInfo ref={_OrderInfoCard} callback={()=>{_LoadEvent(_DateInfo.start,_DateInfo.end);}}/>
        </>
    )
}
export default React.memo(PageCalendar)